import useFlags from 'launchdarkly-react-client-sdk/lib/useFlags';
import { FC } from 'react';
import useParticipantPhoneNumber from './ParticipantPhoneNumberGroup.hook';
import FormGroup from 'components/FormGroup';
import { CommonGroups } from 'modules/events/basics/enums/commonForms.enums';
import Box from 'yoda-ui/components/Box';
import CheckBoxYoda from 'yoda-ui/components/Form/CheckBoxYoda';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const ParticipantPhoneNumberGroup: FC = () => {
  const {
    participantPhoneNumberConfig,
    isCollectParticipantPhoneNumberEnabled,
    t,
  } = useParticipantPhoneNumber();

  const flags = useFlags();

  return (
    <FormGroup title={ t('event_group_participant_phone_number') } groupName={ CommonGroups.participantPhoneNumber }>
      <Box marginBottom={ YodaSpacing.large } display={ 'flex' } flexDirection={ 'column' }>
        <CheckBoxYoda { ...participantPhoneNumberConfig.collectParticipantPhoneNumber } />
        {
          isCollectParticipantPhoneNumberEnabled && (
            <>
              <CheckBoxYoda { ...participantPhoneNumberConfig.collectPhoneNumberMandatory } />
              {
                flags.eventsCweb1342EnableCollectPhoneConsentCheckbox
                && <CheckBoxYoda { ...participantPhoneNumberConfig.collectPhoneNumberUserConsent } />
              }
              <CheckBoxYoda { ...participantPhoneNumberConfig.collectTextMessageUserConsent } />
            </>
          )

        }

      </Box>

    </FormGroup>
  );
};

export default ParticipantPhoneNumberGroup;
